type Props = { className?: string };

export function BrandMark({ className }: Props) {
  return (
    <img
      src="/logo-mark.png"
      alt="Anexya"
      className={className}
      width={282}
      height={349}
      loading="eager"
      decoding="async"
    />
  );
}
